import "./DCM/styles/App.css";
import Header from "./Sidebar_header/header/Header";
import Sidebar from "./Sidebar_header/sidebar/Sidebar";
import TimeTable from "./DCM/components/timeTable";
import "./DCM/styles/header_sidebar.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Redirect,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import SummaryUpdated from "./DCM/components/SummaryUpdated/SummaryUpdated";
// Login And Register
import MainRegister from "./LoginRegister/Registration/MainRegister/MainRegister";
import ManualyCreateTimetable from "./DCM/components/day-event/ManuallyCreateTimetable";
import CreateClassLink from "./DCM/components/CreateClassLink/CreateClassLink";
// ////////////////Login And Register ///////////////////
import VerifyMobileEmail from "./LoginRegister/Registration/VerifyMobile/VerifyMobileEmail";
import EnterEmailOtp from "./LoginRegister/Registration/OTP/EmailOtp/EnterEmailOtp";
import EnterMobileOtp from "./LoginRegister/Registration/OTP/MobileOtp/EnterMobileOtp";
import SetPassWord from "./LoginRegister/Registration/SetPassWord/SetPassWord";
import FourDigitMPin from "./LoginRegister/Registration/MPin/FourDigitMPin";
import LoginWithMPN from "./LoginRegister/Login/LoginWithMPIN/LoginWithMPN";

import LoginWithPassWord from "./LoginRegister/Login/LoginWithPassWord/LoginWithPassWord";
import LoginWithOTP from "./LoginRegister/Login/LoginWithOTP/LoginWithOTP";
import ForgotMPINVerify from "./LoginRegister/Login/ForgotPin/ForgotMPINVerify";
import SetNewMPIN from "./LoginRegister/Login/ForgotPin/SetNewMPIN";
import SetNewPassWord from "./LoginRegister/Login/ForgotPassWord/SetNewPassWord";

// My Profile

import MyProfile from "./MyProfile/MyProfile";
import EditMyProfile from "./MyProfile/EditMyProfile";
import EiditSuccesfully from "./MyProfile/EiditSuccesfully";
import EditDisabled from "./MyProfile/EditDisabled";

// Assessment
import Create from "./Assesment/pages/Create_Assessment/create/Create";
import Assessment from "./Assesment/pages/Create_Assessment/assessment/Assessment";
import AllQuestions from "./Assesment/pages/onreview/onreview_questiontype/AllQuestions";
import PublishedAssessment from "./Assesment/pages/On_going/Published_Assessment/PublishedAssessment";
import ReviewStudentList from "./Assesment/pages/onreview/Review_student_list/ReviewStudentList";
import CompleteStudentList from "./Assesment/pages/Completed/Complet_student_list/CompleteStudentList";
import PublishedQList from "./Assesment/pages/On_going/Published/Published_Q_list/PublishedQList";
import CreateQuestion from "./Assesment/pages/Create_Assessment/Create_Question/CreateQuestion";
import DeativateQList from "./Assesment/pages/On_going/Draft/Deactivate_Q_List/DeativateQList";
import ScheduleQList from "./Assesment/pages/On_going/SChedule/Schedule_Q_List/ScheduleQList";
import EditScheduledQlist from "./Assesment/pages/On_going/SChedule/Schedule_Q_List/EditScheduledQlist";
import DaftQLists from "./Assesment/pages/On_going/Draft/Draft_Q_list/DraftQLists";

// Homework
import CreateHomework from "./Homework/pages/Create_Assessment/createHW/CreateHomework";
import AddHomework from "./Homework/pages/Create_Assessment/AddHomework/AddHomework";
import AllQuestionsHW from "./Homework/pages/onreview/onreview_questiontype/AllQuestions";
import PublishedHomework from "./Homework/pages/On_going/Published_Assessment/PublishedHomework";
import ReviewStudentListHW from "./Homework/pages/onreview/Review_student_list/ReviewStudentListHW";
import CompleteStudentListHW from "./Homework/pages/Completed/Complet_student_list/CompleteStudentListHW";
import CreateQuestionHw from "./Homework/pages/Create_Assessment/Create_Question/CreateQuestionHw";
import AllQuestionsCompleted from "./Homework/pages/Completed/completed_questiontype/AllQuestionsCompletedHW";
import PublishedQListHW from "./Homework/pages/On_going/Published/Published_Q_list/PublishedQListHW";
import Draft_Q_list_HW from "./Homework/pages/On_going/Draft/Draft_Assess_Box/Draft_Q_list/Draft_Q_list_HW";
import ScheduleQListHW from "./Homework/pages/On_going/SChedule/Schedule_Q_List/ScheduleQListHW";
import EditScheduleHw from "./Homework/pages/On_going/SChedule/Schedule_Q_List/EditScheduleHw";
//  PreRead
import AddPreRead from "./Homework/Pre-read/Create_Assessment_PreRead/HomeworkPreRead/AddPreRead";
import CreatePreRead from "./Homework/Pre-read/Create_Assessment_PreRead/create/CreatePreRead";
import CreatePublishPreRead from "./Homework/Pre-read/Create_Assessment_PreRead/create_published/CreatePublishPreRead";
import PublishedHomeworkPreRead from "./Homework/Pre-read/On_going_PreRead/Published_Assessment_PreRead/PublishedHomeworkPreRead";
import PublishedQListPreRead from "./Homework/Pre-read/On_going_PreRead/Published/Published_Q_list/PublishedQListPreRead";
import DraftQlistPreRead from "./Homework/Pre-read/On_going_PreRead/Draft/Draft_Assess_Box/Draft_Q_list/Draft_Q_list_PreRead";
import ScheduleQListPreRead from "./Homework/Pre-read/On_going_PreRead/SChedule/Schedule_Q_List/ScheduleQListPreRead";
import ScheduleEditPreRead from "./Homework/Pre-read/On_going_PreRead/SChedule/Schedule_Q_List/ScheduleEdit_PreRead";
import PublishedEditPre from "./Homework/Pre-read/On_going_PreRead/Published/published_access_box/Published_EditPre";

//Activity
import AddActivity from "./Homework/Activity/Create_Assessment_Activity/Add_Activity_hw/AddActivity";
import CreateActivity from "./Homework/Activity/Create_Assessment_Activity/create/CreateActivity";
import CreatePublishActivity from "./Homework/Activity/Create_Assessment_Activity/create_published/CreatePublishActivity";
// Ongoing Activity
import PublishedHomeworkActivity from "./Homework/Activity/On_going/Published_Assessment/PublishedHomeworkActivity";
import PublishedQListActivity from "./Homework/Activity/On_going/Published/Published_Q_list/PublishedQListActivity";
import DraftQlistActivity from "./Homework/Activity/On_going/Draft/Draft_Assess_Box/Draft_Q_list/Draft_Q_list_Activity";
import ScheduleQListActivity from "./Homework/Activity/SChedule/Schedule_Q_List/ScheduleQListActivity";
//onReview Activity
import ReviewStudentListActivity from "./Homework/Activity/onreview/Review_student_list/ReviewStudentListActivity";
import QuestionnoboxC from "./Homework/Activity/onreview/onreview_component/question_no_box/QuestionnoboxC";
// Completed Activity
import CompletedStudentListActivity from "./Homework/Activity/Completed/Review_student_list/CompletedStudentListActivity";
import QuestionnoboxCompleted from "./Homework/Activity/Completed/Completed_component/question_no_box/QuestionnoboxCompleted";
import EditPublishedActivity from "./Homework/Activity/On_going/Published/Published_Q_list/PublishQuestionType/EditPublishedActivity";
import ScheduleEditActivity from "./Homework/Activity/SChedule/Schedule_Q_List/ScheduleEdit_Activity";

//groups
import CreateGroup from "./Groups/create/CreateGroup";
import GroupMain from "./Groups/assessment/GroupMain";
import CreateMoreGroups from "./Groups/CreteMoreGroup/CreateMoreGroups";
import DeleteGroup from "./Groups/Delete/DeleteGroup";
import SuccessGroupmsg from "./Groups/SucessGroup/SuccessGroupmsg";
import AddMemebers from "./Groups/AddMemeber/AddMemebers";
import SuceesMemberDeleteMsg from "./Groups/SucessGroup/SuceesMemberDeleteMsg";
import DeleteGroupMember from "./Groups/Delete/DeleteGroupMember";
import Upload from "./Groups/UploadFile/components/Upload";

//Engagement
import TotalCommuPost from "./Enagagment/pages/Open_community/total_community_post/TotalCommuPost";
import CreateCommunity from "./Enagagment/pages/Create_channel/Create/Create";
import ViewFirstScreen from "./Enagagment/pages/Create_channel/View_Channel_Screen/View_First_Screen/ViewFirstScreen";
import FeedDetail from "./Enagagment/pages/Open_community/Feed_Detail/FeedDetail";
import GroupWiseQuery from "./Enagagment/pages/Teacher/Group_Wise_Query/GroupWiseQuery";
import ValidSchoolId from "./LoginRegister/Registration/ValidSchool_ld.js/ValidSchool_Id";
import GroupList from "./Groups/CreteMoreGroup/GroupList";
import ReviewCompletedStudentData from "./Homework/Activity/onreview/onreview_component/ReviewCompletedStudentData";
//Content Management
import ContentMangment from "./ContentManagement/Main_CM/ContentMangment";
import ScheduleQListQB from "./ContentManagement/QuestionbankCM/ViewQuestion/ScheduleQListQB";
import QuestionListQB from "./ContentManagement/QuestionbankCM/EditQBank/QuestionListQB";
import LibrarySubjectDetail from "./ContentManagement/Library/LibraySubjectDatail/LibrarySubjectDetail";
import ChapterVideo from "./ContentManagement/Library/VideoLect/ChapterVideo";
import CreateNewQB from "./ContentManagement/QuestionbankCM/CreateNewQB/CreateNewQB";
import CreateQuestionsQB from "./ContentManagement/QuestionbankCM/CreateOptionQuestions/CreateQuestionsQB";
import LibraryTemplate from "./ContentManagement/LibraryTemplate/LibraryTemplate";
import TemplateDetailCM from "./ContentManagement/LibraryTemplate/TemplateDetail/TemplateDetailCM";

import "./master_style.css";
import "./Homework/hw_master.css";
import { useEffect, useState } from "react";
import SubjectDateailCM from "./ContentManagement/LiveSession/LiveSessionDetail.js/SubjectDatailsCM/SubjectDateailCM";
import EditQBank from "./ContentManagement/QuestionbankCM/EditQBank/EditQBank";
import LoginSuccess from "./LoginRegister/Login/LoginWithOTP/LoginSuccess";
import PublishedStudentScr from "./Assesment/pages/On_going/Published/published_access_box/PublishedStudentScr";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSkills,
  fetchDifficultyLevels,
  fetchQuestionTypes,
  fetchDomainData,
  setRouteLoading,
} from "./redux/initialDataSlice";
import { setActiveMenu } from "./redux/PageSlice";
import ComponentType from "./Enum/ComponentTypeEnum";
import QuestionCreateMain from "./Components/QuestionCreateMain";
import QuestionEditMain from "./Components/QuestionEditMain";
import Loader from "./Helper/Loader";
import zIndex from "@mui/material/styles/zIndex";
import LactureManagement from "./Pages/LactureManagement";
import ContentLibrary from "./Pages/ContentLibrary";
import QuestionLibrary from "./Pages/QuestionLibrary";
import ActiveMenuEnum from "./Enum/ActiveMenuEnum";
import CompletedAdaptiveQs from "./Assesment/pages/Completed/CompletedAdaptiveQues/CompletedAdaptiveQs";
import MarkAttendance from "./StudentAttendance/MarkAttendance/MarkAttendance";
import NotifyShortage from "./StudentAttendance/NotifyShortage/NotifyShortage";
import Report from "./StudentAttendance/Report/Report";
import LeaveManagement from "./StudentAttendance/Leave Management/LeaveManagement";
import StudentPerformance from "./Student-performance/StudentPerformance";
import OfflinePerformance from "./Student-performance/OfflinePerformance/OfflinePerformance";
import AddReport from "./Student-performance/AddReport/AddReport";
import OfflineSubDraftCompleted from "./Student-performance/OfflineSubDraftCompleted/OfflineSubDraftCompleted";
import OfflineCompletedAssess from "./Student-performance/OfflineSubDraftCompleted/OfflineCompletedAssess";
import MyStudents from "./MyStudents/MyStudents";
import AttendanceToday from "./TeacherHr/AttendanceToday";
import AttendanceHistory from "./TeacherHr/AttendanceHistory";
import AttendanceReport from "./TeacherHr/AttendanceReport";
import LeaveApply from "./TeacherHr/LeaveApply";
import LeaveMyRequests from "./TeacherHr/LeaveMyRequests";
import LeaveBalances from "./TeacherHr/LeaveBalances";
import PayslipsList from "./TeacherHr/PayslipsList";
import PayslipDetail from "./TeacherHr/PayslipDetail";
import SuccessPage from "./LoginRegister/Login/LoginWithOTP/SuccessPage";
import FeatureGuide from "./Components/featureGuide";
import NotAuthorized from "./Components/NotAuthorized";
import { fullAsessment, hasFeature } from "./Utils/features";
import NotFound from "./DCM/components/NotFound";

import SessionExpiredDialog from "./DCM/components/SessionExpiredDialog ";
import { useAuth } from "./context/AuthContext";
import { authStore } from "./store/authStore";
import OfflinePerformanceReport from "./Student-performance/OfflineSubDraftCompleted/OfflinePerformanceReport";
import CompetencyPage from "./Student-performance/CompetencyPage/competencyPage";
import AddCompetency from "./Student-performance/CompetencyPage/addCompetency";
import CompetencyEvalReport from "./Student-performance/CompetencyPage/competencyEvalReport";
import DraftCompetencyReport from "./Student-performance/CompetencyPage/DraftCompetencyReport";
import CompletedCompetencyReport from "./Student-performance/CompetencyPage/completedCompetencyReport";
import OsmMarkingPage from "./osm/pages/OsmMarkingPage";
import OsmListPage from "./osm/pages/OsmListPage";

// const validateLogin = () => {
//   let name = localStorage.getItem("UserName");
let timeTableId = localStorage.getItem("timeTableSessionId");
//   if (name && timeTableId) {
//     return true;
//   } else {
//     return false;
//   }
// };

const validateLogin = (feature) => {
  const isLoggedIn = !!localStorage.getItem("UserName");
  if (!isLoggedIn) return false;

  if (feature && !hasFeature(feature)) {
    return false;
  }

  return true;
};

console.log("validateLogin", validateLogin("ADAPT_ASS"));
console.log("fullAsessment", fullAsessment);

function App() {
  const dispatch = useDispatch();
  const skillsData = useSelector((state) => state.initialData.skills);
  const questionType = useSelector((state) => state.initialData.questionTypes);
  const difficultyLevel = useSelector(
    (state) => state.initialData.difficultyLevels,
  );
  const domain = useSelector((state) => state.initialData.domain);
  const routeLoading = useSelector((state) => state.initialData.isRouteLoading);
  const school_id = localStorage.getItem("schoolId");
  const navigate = useNavigate();

  useEffect(() => {
    if (domain.length === 0) {
      dispatch(fetchDomainData());
    }
    if (skillsData.length === 0) {
      dispatch(fetchSkills());
    }
    if (questionType.length === 0 && school_id !== null) {
      dispatch(fetchQuestionTypes(JSON.parse(school_id)));
    }
    if (difficultyLevel.length === 0) {
      dispatch(fetchDifficultyLevels());
    }
    dispatch(setRouteLoading(false));
  }, [school_id, dispatch]);

  const jsonRole_CTinformation = JSON.parse(
    localStorage.getItem("role_as_class_teacher"),
  );
  const jsonRole_Coinformation = JSON.parse(
    localStorage.getItem("role_as_co_ordinator"),
  );
  const jsonRole_Geinformation = JSON.parse(
    localStorage.getItem("general_role"),
  );

  const [leftSidebarSize, setLeftSidebarSize] = useState();

  const location = useLocation();

  const { sessionExpired, setSessionExpired } = useAuth();

  useEffect(() => {
    authStore.setSetter(setSessionExpired);
  }, []);

  useEffect(() => {
    const path = location.pathname;

    if (
      path.startsWith("/PublishedHomework") &&
      !path.includes("PreRead") &&
      !path.includes("Activity")
    ) {
      dispatch(setActiveMenu(ActiveMenuEnum.HM));
    } else if (path.startsWith("/PublishedHomeworkPreRead")) {
      dispatch(setActiveMenu(ActiveMenuEnum.PR));
    } else if (path.startsWith("/PublishedHomeworkActivity")) {
      dispatch(setActiveMenu(ActiveMenuEnum.ACTIVITY));
    } else if (path.startsWith("/DcmTimeTable")) {
      dispatch(setActiveMenu(ActiveMenuEnum.DSM));
    } else if (path.startsWith("/tea-attendance-today")) {
      dispatch(setActiveMenu(ActiveMenuEnum.TEA_ATT_TODAY));
    } else if (path.startsWith("/tea-attendance-history")) {
      dispatch(setActiveMenu(ActiveMenuEnum.TEA_ATT_HISTORY));
    } else if (path.startsWith("/tea-attendance-report")) {
      dispatch(setActiveMenu(ActiveMenuEnum.TEA_ATT_REPORT));
    } else if (path.startsWith("/tea-leave-apply")) {
      dispatch(setActiveMenu(ActiveMenuEnum.TEA_LEAVE_APPLY));
    } else if (path.startsWith("/tea-leave-requests")) {
      dispatch(setActiveMenu(ActiveMenuEnum.TEA_LEAVE_LIST));
    } else if (path.startsWith("/tea-leave-balances")) {
      dispatch(setActiveMenu(ActiveMenuEnum.TEA_LEAVE_BALANCES));
    } else if (
      path.startsWith("/tea-payslips") ||
      path.startsWith("/tea-payslip/")
    ) {
      dispatch(setActiveMenu(ActiveMenuEnum.SALARY_PAYSLIPS));
    }
  }, [location.pathname, dispatch]);

  const handleLogout = () => {
    localStorage.clear();
    setSessionExpired(false);
    navigate("/");
  };

  // useEffect(() => {
  //   runOsmTest().catch(console.error);
  // }, []);

  return (
    <>
      <SessionExpiredDialog open={sessionExpired} onConfirm={handleLogout} />
      {routeLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            zIndex: 558,
            background: "#2726265e",
            width: "100vw",
            height: "100vh",
          }}
          className="d-flex justify-content-center align-items-center"
        >
          <Loader />
        </div>
      )}
      <div className="Assesment">
        <ToastContainer
          style={{ zIndex: 999999 }}
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Sidebar setLeftSidebarSize={setLeftSidebarSize} />
        <div className="Assesment_Wrap">
          <Header
            jsonRole_CTinformation={jsonRole_CTinformation}
            jsonRole_Coinformation={jsonRole_Coinformation}
            jsonRole_Geinformation={jsonRole_Geinformation}
          />
          <div
            className="m-3 Main_Container"
            style={{ paddingBottom: 0, overflow: "hidden" }}
          >
            <Routes>
              <Route exact path="/" element={<ValidSchoolId />} />
              <Route exact path="/Register" element={<MainRegister />} />
              <Route
                exact
                path="/VerifyMobileEmail"
                element={<VerifyMobileEmail />}
              />
              <Route exact path="/EnterEmailOtp" element={<EnterEmailOtp />} />
              <Route
                exact
                path="/EnterMobileOtp"
                element={<EnterMobileOtp />}
              />
              <Route exact path="/SetPassWord" element={<SetPassWord />} />
              <Route exact path="/FourDigitMPin" element={<FourDigitMPin />} />
              <Route
                exact
                path="/LoginWithMpin"
                element={
                  <LoginWithMPN setLeftSidebarSize={setLeftSidebarSize} />
                }
              />
              <Route
                exact
                path="/LoginWithPassWord"
                element={<LoginWithPassWord />}
              />
              <Route exact path="/LoginWithOTP" element={<LoginWithOTP />} />
              <Route
                exact
                path="/ForgotMPINVerify"
                element={<ForgotMPINVerify />}
              />
              <Route exact path="/SetNewMPIN" element={<SetNewMPIN />} />
              <Route
                exact
                path="/SetNewPassWord"
                element={<SetNewPassWord />}
              />
              <Route exact path="/MyProfile" element={<MyProfile />} />
              <Route exact path="/EditProfile" element={<EditMyProfile />} />
              <Route
                exact
                path="/SuccesfullyEditProfile"
                element={<EiditSuccesfully />}
              />
              <Route
                exact
                path="/DisabledEditProfile"
                element={<EditDisabled />}
              />
              <Route
                exact
                path="/403/unauthorized"
                element={<NotAuthorized />}
              />
              <Route
                path="/DcmTimeTable"
                element={
                  validateLogin() ? (
                    <TimeTable leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/ViewSummary"
                element={
                  validateLogin() ? <SummaryUpdated /> : <Navigate to="/" />
                }
              />
              <Route
                //Insted of id it is showing true
                path="/createTimeTableManually/:isEditable"
                element={
                  validateLogin("TTBL_MGT") ? (
                    <ManualyCreateTimetable leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                exact
                path="/lactureManagement"
                element={
                  validateLogin("TTBL_MGT") ? (
                    <LactureManagement />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                exact
                path="/contentLibrary"
                element={
                  validateLogin("CONT_LIB") ? (
                    <ContentLibrary />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                exact
                path="/questionLibrary"
                element={
                  validateLogin("QUES_LIB") ? (
                    <QuestionLibrary />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/createClassLink"
                element={
                  validateLogin() ? <CreateClassLink /> : <Navigate to="/" />
                }
              />
              <Route
                exact
                path="/AddAssessment"
                element={
                  validateLogin() && fullAsessment ? (
                    <Assessment />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/create"
                element={
                  validateLogin() && fullAsessment ? (
                    <QuestionCreateMain
                      componentType={ComponentType.ASSESSMENT}
                    />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                } //<Create />
              />
              <Route
                path="/createAssessment"
                element={validateLogin() ? <Create /> : <Navigate to="/" />} //<Create />
              />
              <Route path="/loginSuccess" element={<LoginSuccess />} />
              <Route
                path="/successpage"
                element={
                  validateLogin() ? <SuccessPage /> : <Navigate to="/" />
                }
              />
              <Route
                exact
                path="/PublishedAssessment"
                element={
                  validateLogin() && fullAsessment ? (
                    <PublishedAssessment leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/onreviewstudentlist"
                element={
                  validateLogin() && fullAsessment ? (
                    <ReviewStudentList />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              {/* Don't read id from backend */}
              <Route
                path="/reviewallquestions"
                element={
                  validateLogin() && fullAsessment ? (
                    <AllQuestions />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/reviewallquestions/adaptive/completedassessment"
                element={
                  validateLogin() ? (
                    <CompletedAdaptiveQs />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/CompleteStudentList"
                element={
                  validateLogin() && fullAsessment ? (
                    <CompleteStudentList />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/publishedStudentList"
                element={
                  validateLogin() && fullAsessment ? (
                    <PublishedStudentScr leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/PublishedQList"
                element={
                  validateLogin() && fullAsessment ? (
                    <PublishedQList />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/DeativateQList"
                element={
                  validateLogin() ? <DeativateQList /> : <Navigate to="/" />
                }
              />
              <Route
                path="/DaftQLists"
                element={
                  validateLogin() && fullAsessment ? (
                    <DaftQLists componentType={ComponentType.ASSESSMENT} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/ScheduleQList"
                element={
                  validateLogin() && fullAsessment ? (
                    <ScheduleQList />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/EditScheduledQList"
                element={
                  validateLogin() && fullAsessment ? (
                    <EditScheduledQlist
                      componentType={ComponentType.ASSESSMENT}
                    />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                exact
                path="/AddHomework"
                element={
                  validateLogin("AS_HW") ? (
                    <AddHomework />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/CreateHomework"
                element={
                  validateLogin("AS_HW") ? (
                    <CreateHomework />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/createQuestionHomework"
                element={
                  validateLogin() ? <CreateQuestionHw /> : <Navigate to="/" />
                }
              />
              <Route
                exact
                path="/PublishedHomework"
                element={
                  validateLogin("AS_HW") ? (
                    <PublishedHomework leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/onreviewstudentlistHW"
                element={
                  validateLogin("AS_HW") ? (
                    <ReviewStudentListHW />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/reviewallquestionsHW"
                element={
                  validateLogin("AS_HW") ? (
                    <AllQuestionsHW />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/Completedallquestions"
                element={
                  validateLogin("AS_HW") ? (
                    <AllQuestionsCompleted />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/CompleteStudentListHW"
                element={
                  validateLogin("AS_HW") ? (
                    <CompleteStudentListHW />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/PublishedQListHW"
                element={
                  validateLogin("AS_HW") ? (
                    <PublishedQListHW />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/Draft_Q_list_HW"
                element={
                  validateLogin("AS_HW") ? (
                    <Draft_Q_list_HW componentType={ComponentType.HOMEWORK} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/ScheduleQListHW"
                element={
                  validateLogin("AS_HW") ? (
                    <ScheduleQListHW />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/EditScheduleHw"
                element={
                  validateLogin("AS_HW") ? (
                    <EditScheduleHw />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                exact
                path="/AddPreRead"
                element={
                  validateLogin("AS_PR") ? (
                    <AddPreRead />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/createPreRead"
                element={
                  validateLogin("AS_PR") ? (
                    <CreatePreRead />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/PublishPreRead"
                element={
                  validateLogin("AS_PR") ? (
                    <CreatePublishPreRead />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/PublishedHomeworkPreRead"
                element={
                  validateLogin("AS_PR") ? (
                    <PublishedHomeworkPreRead
                      leftSidebarSize={leftSidebarSize}
                    />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/PublishedQListPreRead"
                element={
                  validateLogin("AS_PR") ? (
                    <PublishedQListPreRead />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                // (Edit Code is comment in the code)
                path="/PublishedEditPre/:publicPreread_id"
                element={
                  validateLogin() ? <PublishedEditPre /> : <Navigate to="/" />
                }
              />
              <Route
                path="/DraftQlistPreRead"
                element={
                  validateLogin("AS_PR") ? (
                    <DraftQlistPreRead />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/ScheduleQListPreRead"
                element={
                  validateLogin() ? (
                    <ScheduleQListPreRead />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/ScheduleEdit_PreReads"
                element={
                  validateLogin() ? (
                    <ScheduleEditPreRead />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                exact
                path="/AddActivity"
                element={
                  validateLogin("AS_ACT") ? (
                    <AddActivity />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                exact
                path="/CreateActivity"
                element={
                  validateLogin("AS_ACT") ? (
                    <CreateActivity />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                exact
                path="/CreatePublishActivity"
                element={
                  validateLogin("AS_ACT") ? (
                    <CreatePublishActivity />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                exact
                path="/PublishedHomeworkActivity"
                element={
                  validateLogin("AS_ACT") ? (
                    <PublishedHomeworkActivity
                      leftSidebarSize={leftSidebarSize}
                    />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/PublishedQListActvity"
                element={
                  validateLogin() ? (
                    <PublishedQListActivity />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                // EditPublishedActivity_id is not use anywhere in code
                path="/EditPublishedActivity/:EditPublishedActivity_id"
                element={
                  validateLogin() ? (
                    <EditPublishedActivity />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                exact
                path="/DraftQlistActivity"
                element={
                  validateLogin("AS_ACT") ? (
                    <DraftQlistActivity />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/ScheduleQListActivity"
                element={
                  validateLogin() ? (
                    <ScheduleQListActivity />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/ScheduleEditActivity"
                element={
                  validateLogin() ? (
                    <ScheduleEditActivity />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/StudentListActivity"
                element={
                  validateLogin("AS_ACT") ? (
                    <ReviewStudentListActivity />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/QuestionnoboxActivityReview"
                element={
                  validateLogin("AS_ACT") ? (
                    <QuestionnoboxC />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/ReviewCompletedStudentData"
                element={
                  validateLogin("AS_ACT") ? (
                    <ReviewCompletedStudentData />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/CompletedStudentListActivity"
                element={
                  validateLogin("AS_ACT") ? (
                    <CompletedStudentListActivity />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/QuestionnoboxCompletedActivity"
                element={
                  validateLogin("AS_ACT") ? (
                    <QuestionnoboxCompleted />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                exact
                path="/AddGroups"
                element={
                  validateLogin("COMMUNITY") ? (
                    <GroupMain />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/createGroups"
                element={
                  validateLogin("COMMUNITY") ? (
                    <CreateGroup />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/createMoreGroups"
                element={
                  validateLogin("COMMUNITY") ? (
                    <CreateMoreGroups />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/DleteGroup"
                element={
                  validateLogin("COMMUNITY") ? (
                    <DeleteGroup />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/DeleteSucessfulyGroup"
                element={
                  validateLogin("COMMUNITY") ? (
                    <SuccessGroupmsg />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/DeleteSucessfulyGroupMember"
                element={
                  validateLogin("COMMUNITY") ? (
                    <SuceesMemberDeleteMsg />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/DeleteMember"
                element={
                  validateLogin() ? <DeleteGroupMember /> : <Navigate to="/" />
                }
              />
              <Route
                path="/addmember"
                element={
                  validateLogin() ? <AddMemebers /> : <Navigate to="/" />
                }
              />
              <Route
                path="/FileUploading"
                element={validateLogin() ? <Upload /> : <Navigate to="/" />}
              />
              <Route
                exact
                path="/CreateCommunity"
                element={
                  validateLogin("COMMUNITY") ? (
                    <CreateCommunity />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/TotalCommuPost"
                element={
                  validateLogin("COMMUNITY") ? (
                    <TotalCommuPost />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/viewFirstScreen"
                element={
                  validateLogin("COMMUNITY") ? (
                    <ViewFirstScreen />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/feedDetail"
                element={
                  validateLogin("COMMUNITY") ? (
                    <FeedDetail />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/queryGroups"
                element={
                  validateLogin("DOUBT_SOLV") ? (
                    <GroupList />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/groupWiseQuery"
                element={
                  validateLogin("DOUBT_SOLV") ? (
                    <GroupWiseQuery />
                  ) : (
                    <Navigate to="403/unauthorized/" />
                  )
                }
              />
              {/* contentManagement */}
              {/* <Route
                path="/contentMangment"
                element={
                  validateLogin() ? <ContentMangment /> : <Navigate to="/" />
                }
              /> */}
              <Route
                path="/liveSession"
                element={
                  validateLogin("LEC_SUM") ? (
                    <SubjectDateailCM />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/library/subjectDetails"
                element={
                  validateLogin("CONT_LIB") ? (
                    <LibrarySubjectDetail />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/chapterContent"
                element={
                  validateLogin("CONT_LIB") ? (
                    <ChapterVideo />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/createQuestion"
                element={
                  validateLogin("QUES_LIB") ? (
                    <CreateNewQB leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/editQuestionBank"
                element={
                  validateLogin("QUES_LIB") ? (
                    <EditQBank componentType={ComponentType.QUESTION_BANK} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/CreateQuestionsQB"
                element={
                  validateLogin() ? <CreateQuestionsQB /> : <Navigate to="/" />
                }
              />
              {/* <Route
                path="/LibraryTemplate"
                element={
                  validateLogin() ? <LibraryTemplate /> : <Navigate to="/" />
                }
              /> */}
              {/* <Route
                path="/TemplateDetailCM"
                element={
                  validateLogin() ? <TemplateDetailCM /> : <Navigate to="/" />
                }
              /> */}
              <Route
                path="/qBankDetails"
                element={
                  validateLogin("QUES_LIB") ? (
                    <ScheduleQListQB />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/markattendance"
                element={
                  validateLogin("STUD_ATT") ? (
                    <MarkAttendance />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/notifyshortage"
                element={
                  validateLogin("STUD_ATT") ? (
                    <NotifyShortage />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/attendancereport"
                element={
                  validateLogin("STUD_ATT") ? (
                    <Report leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/leavemanagement"
                element={
                  validateLogin("STUD_ATT") ? (
                    <LeaveManagement />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/tea-attendance-today"
                element={
                  validateLogin("TEACH_ATT") ? (
                    <AttendanceToday />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/tea-attendance-history"
                element={
                  validateLogin("TEACH_ATT") ? (
                    <AttendanceHistory />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/tea-attendance-report"
                element={
                  validateLogin("TEACH_ATT") ? (
                    <AttendanceReport />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/tea-leave-apply"
                element={
                  validateLogin("TEACH_ATT") ? (
                    <LeaveApply />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/tea-leave-requests"
                element={
                  validateLogin("TEACH_ATT") ? (
                    <LeaveMyRequests />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/tea-leave-balances"
                element={
                  validateLogin("TEACH_ATT") ? (
                    <LeaveBalances />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/tea-payslips"
                element={
                  validateLogin("SALARY_MGT") ? (
                    <PayslipsList />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/tea-payslip/:id"
                element={
                  validateLogin("SALARY_MGT") ? (
                    <PayslipDetail />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/student-performance"
                element={
                  validateLogin("OL_PERF") ? (
                    <StudentPerformance leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/offline-performance/academic"
                element={
                  validateLogin("OFFL_PERF") ? (
                    <OfflinePerformance leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/offline-performance/competency"
                element={
                  validateLogin("OFFL_PERF") ? (
                    <CompetencyPage leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/add-report"
                element={
                  validateLogin("OFFL_PERF") ? (
                    <AddReport />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/add-competency"
                element={
                  validateLogin("OFFL_PERF") ? (
                    <AddCompetency />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/offline-submission-report"
                element={
                  validateLogin("OFFL_PERF") ? (
                    <OfflineSubDraftCompleted />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/draft-competency-report"
                element={
                  validateLogin("OFFL_PERF") ? (
                    <DraftCompetencyReport />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/completed-competency-report"
                element={
                  validateLogin("OFFL_PERF") ? (
                    <CompletedCompetencyReport />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/competency-evaluation-report"
                element={
                  validateLogin("OFFL_PERF") ? (
                    <CompetencyEvalReport />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/offline-completed-assessment"
                element={
                  validateLogin("OFFL_PERF") ? (
                    <OfflineCompletedAssess />
                  ) : (
                    <Navigate to="/403/unauthorized" />
                  )
                }
              />
              <Route
                path="/my-students"
                element={
                  validateLogin() ? (
                    <MyStudents leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/offlineperformancereport"
                element={
                  validateLogin("PERFORMANCE_REPORT") ? (
                    <OfflinePerformanceReport
                      leftSidebarSize={leftSidebarSize}
                    />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/osm"
                element={
                  validateLogin("OSM_MARK") ? (
                    <OsmListPage />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/osm/:scriptId"
                element={
                  validateLogin("OSM_MARK") ? (
                    <OsmMarkingPage />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                exact
                path="/feature-guide"
                element={
                  validateLogin() ? (
                    <FeatureGuide leftSidebarSize={leftSidebarSize} />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              \
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
